import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { FailedAlternatives } from './components/FailedAlternatives';
import { SolutionIntro } from './components/SolutionIntro';
import { AboutJose } from './components/AboutJose';
import { Services } from './components/Services';
import { BeforeAfter } from './components/BeforeAfter';
import { Gallery } from './components/Gallery';
import { LifeBack } from './components/LifeBack';
import { ServiceAreas } from './components/ServiceAreas';
import { GoogleReviews } from './components/GoogleReviews';
import { Guarantee } from './components/Guarantee';
import { WhoFor } from './components/WhoFor';
import { FinalCTA } from './components/FinalCTA';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
import { FloatingActions } from './components/FloatingActions';
export function App() {
  return <div className="min-h-screen bg-[#F9F9F9] font-sans selection:bg-[#C8102E] selection:text-white" data-id="element-0" data-mp="23ti7s3go4sjo">
      <Navbar data-id="element-1" data-mp="3ii4qhxkeukmg" />
      <main data-id="element-2" data-mp="3mlaxx8j9ehui">
        <Hero data-id="element-3" data-mp="3ml17jjuay8oa" />
        <PainSection data-id="element-4" data-mp="3mkho1yp07c85" />
        <FailedAlternatives data-id="element-5" data-mp="3mjq1fdddwou0" />
        <SolutionIntro data-id="element-6" data-mp="3rc9f0ac2njyt" />
        <AboutJose data-id="element-7" data-mp="3rbrc4uuwm7hx" />
        <Services data-id="element-8" data-mp="3rdatypw7kqlt" />
        <BeforeAfter data-id="element-9" data-mp="3rd1bdndhtlq5" />
        <Gallery data-id="element-10" data-mp="3relvej26lm9r" />
        <LifeBack data-id="element-11" data-mp="5or2zhbcs60" />
        <ServiceAreas data-id="element-12" data-mp="6817u0q2c9h" />
        <GoogleReviews data-id="element-13" data-mp="5gez9t0lqvv" />
        <Guarantee data-id="element-14" data-mp="82jf0klzq9v" />
        <WhoFor data-id="element-15" data-mp="2zl3cxocsjc6w" />
        <FinalCTA data-id="element-16" data-mp="2zlld2w2kqak3" />
        <FAQ data-id="element-17" data-mp="2zm4v0cs84yy4" />
      </main>
      <Footer data-id="element-18" data-mp="2zmwhmy3ufmc9" />
      <FloatingActions data-id="element-19" data-mp="2zng0ch1bierc" />
    </div>;
}